import { z } from "zod";

export const permitModes = ["one_time", "bounded_reuse"] as const;

export type PermitMode = (typeof permitModes)[number];

export const permitClaimsSchema = z.object({
  iss: z.string().min(1),
  sub: z.string().min(1),
  jti: z.string().min(1),
  iat: z.number().int(),
  exp: z.number().int(),
  workspace_id: z.string().min(1),
  environment: z.enum(["sandbox", "production"]),
  action_type: z.string().min(1),
  payload_fingerprint: z.string().min(1),
  request_id: z.string().min(1),
  decision_source: z.enum(["policy", "approval"]),
  /** SHA-256 of the tool JSON schema at authorization time; present when issued via MCP adapter */
  tool_hash: z.string().length(64).optional(),
  /** Default "one_time"; legacy permits issued before this field existed behave as "bounded_reuse" */
  permit_mode: z.enum(permitModes).optional(),
  /** Origin system tag for audit (e.g. "openai_mcp", "hubspot_wf") */
  origin_system: z.string().optional(),
  /** Stable ID of the agent that requested the action */
  agent_id: z.string().optional()
});

export type PermitClaims = z.infer<typeof permitClaimsSchema>;
